
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import CarNumber from "@/components/CarNumber.vue";

  @Component({
    components: {
      CarNumber,
    },
  })
  export default class CarListCard extends Vue {
    @Prop() car: ICar.IEntity;

    $refs: any;
    statuses = ICar.CarStatusId;
    carStatusesMap = {};

    get printStatus() { return [4, 5].includes(this.car.carStatusId); }

    async openCarPopup() {
      await this.$store.dispatch('car/openCarPopup', { carId: this.car.carId });
    }

    mounted() {
      const carStatusesMap = this.$store.state.book.books.carStatuses;

      carStatusesMap.forEach((item) => {
        Vue.set(this.carStatusesMap, item.id, item);
      });
    }

    @Watch('car')
    onCarChange() {
      this.$nextTick(() => this.$refs.cardCarNumber.prepareData());
    }
  }
